import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
// @ts-expect-error not migrated to TS
import PhoneNumberInput from 'ui-addon-i18n/components/PhoneNumberInput';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { GetACallSuccessModal } from './GetACallSuccessModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GetACallModal = ({
  apiName,
  onBackClick,
  onClose,
  trackingData
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isPhoneNumberSubmitted, setIsPhoneNumberSubmitted] = useState(false);
  const handleSubmit = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'submitted phone number'
    }, getTrackingProperties({
      apiName,
      trackingData
    })));
    setIsPhoneNumberSubmitted(true);
  };
  const handleInputChange = ({
    phoneNumber: phoneNumberValue
  }) => {
    setPhoneNumber(phoneNumberValue);
  };
  if (isPhoneNumberSubmitted) {
    return /*#__PURE__*/_jsx(GetACallSuccessModal, {
      onClose: onClose
    });
  }
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 650,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.callTitle"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "stretch",
        "data-test-id": "communication-selected-method-call",
        gap: "600",
        children: [/*#__PURE__*/_jsx(PhoneNumberInput, {
          defaultValue: phoneNumber,
          value: phoneNumber,
          onChange: handleInputChange,
          "data-test-id": "phone-number-input"
        }), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "400",
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: handleSubmit,
            use: "primary",
            disabled: !phoneNumber,
            "data-test-id": "submit-button",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "purchaseMotions.talkToSales.communicationMethods.callButton"
            })
          }), /*#__PURE__*/_jsx(Button, {
            "data-test-id": "communication-call-back-button",
            use: "link",
            onClick: () => onBackClick(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "purchaseMotions.talkToSales.communicationMethods.backButton"
            })
          })]
        })]
      })
    })]
  });
};